export default __webpack_public_path__ + "static/media/placeholder.af44ed25.png";